import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import FavouriteRow from './FavouriteRow';
import Row from '../atoms/FlexRow';
import Checkbox from '../atoms/Checkbox';
import HorSpacer from '../atoms/HorSpacer';
import Btn from '../atoms/Button';
import Txt from '../atoms/Txt';
import { remFavorie } from '../../database/repositories/FavoriteRepository';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: grid;
  }
`;

function FavouritesTab({ tabId, style, props }) {
  const userData = useSelector((state) => state.auth.user_data);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [allChecked, setAllChecked] = useState(false);

  const ensureCheck = (prodID) => {
    if (selectedProducts.includes(prodID)) {
      return setSelectedProducts(selectedProducts.filter((id) => id !== prodID));
    }
    return setSelectedProducts(selectedProducts.concat(prodID));
  };

  const deleteProductsFromFavs = async () => {
    if (selectedProducts.length === 0) return;

    await remFavorie(...selectedProducts);
    setAllChecked(false);
    setSelectedProducts([]);
  };

  return (
    <Container id={tabId} style={style} {...props}>
      <Row justify="flex-start" padding="30px 30px 20px 30px">
        <Checkbox value={allChecked} onClick={() => setAllChecked(!allChecked)} />
        <HorSpacer size={25} />
        <Btn onClick={deleteProductsFromFavs}>Excluir</Btn>
        <HorSpacer fill />
        <Txt>
          Favoritos 1 - {userData?.favs?.length ?? 0} de {userData?.favs?.length ?? 0}
        </Txt>
      </Row>
      {
        console.log(userData?.favs),
        userData?.favs[0] ? (
          userData?.favs?.map((fav) => (
            <FavouriteRow
              checked={allChecked || selectedProducts.includes(fav)}
              onCheck={() => ensureCheck(fav)}
              prodId={fav}
            />
          ))
        ) : (<p>Sem favoritos</p>)
      }
    </Container>
  );
}

export default FavouritesTab;
